import { defineComponent } from "vue";
import StateSvg from "@common/vue/StateSvg.vue";
import { liveStore } from "@live/store/LiveStore";
import LoadingIndicator from "@common/vue/LoadingIndicator.vue";
import MapboxScene from "./MapboxScene";
import { SET_CURRENT_AIRPORT_BY_ICAO, SET_CURRENT_FLIGHT_BY_ID } from "@live/store/LiveActions";
import { SET_IS_FLIGHT_FOCUS } from "@live/store/LiveMutations";
import { MapApi } from "../../api/map/MapApi";
export default defineComponent({
    mapScene: null,
    components: {
        StateSvg,
        LoadingIndicator
    },
    props: {
        flights: {
            type: Object,
        },
        airports: {
            type: Object,
        },
        isTargetingFlight: {
            type: Boolean,
            default: false
        },
        currentFlight: {
            type: Object,
            default: false
        }
    },
    computed: {
        isOverlayVisible: function () {
            const isOverlayVisible = this.$store.getters.getIsOverlayVisible;
            return isOverlayVisible;
        },
        isServerFlightsLoading: function () {
            const isServerFlightsLoading = liveStore.getters.getIsServerDetailLoading;
            return isServerFlightsLoading;
        }
    },
    watch: {
        isTargetingFlight: function () {
            const mapScene = this.$options.mapScene;
            if (mapScene == null) {
                console.warn("Could not target flight (null mapScene)");
                return;
            }
            const flight = liveStore.getters.getCurrentFlightSimple;
            if (flight == null) {
                return;
            }
            mapScene.targetFlight(flight);
        },
        flights: function (newFlights) {
            if (newFlights == undefined) {
                console.error("Could not update flights (undefined)");
                return;
            }
            const mapScene = this.$options.mapScene;
            if (mapScene == null) {
                console.warn("Could not set flights (null mapScene)");
                return;
            }
            mapScene.refreshFlights(newFlights);
        },
        airports: function (newAirports) {
            if (newAirports == undefined) {
                console.error("Could not update airports (undefined)");
                return;
            }
            const mapScene = this.$options.mapScene;
            if (mapScene == null) {
                console.warn("Could not set airports (null mapScene)");
                return;
            }
            mapScene.refreshAirports(newAirports);
        },
        currentFlight: function (newFlight) {
            const mapScene = this.$options.mapScene;
            if (mapScene == null) {
                console.warn("Could not set route (null mapScene)");
                return;
            }
            mapScene.refreshRoute(newFlight);
        }
    },
    methods: {
        onClickEarth: function () {
            this.$emit("onClickEarth");
        }
    },
    mounted: async function () {
        let mapboxToken = "";
        try {
            mapboxToken = await MapApi.getMapboxToken(this.$store.getters.getJwtToken);
        }
        catch (e) {
            console.error(e);
            this.$emit("onClickEarth");
            return;
        }
        const mapScene = new MapboxScene("mapbox-view-container", mapboxToken);
        if (this.flights != undefined) {
            mapScene.refreshFlights(this.flights);
            mapScene.setOnClickFlights((id) => {
                liveStore.commit(SET_IS_FLIGHT_FOCUS, true);
                liveStore.dispatch(SET_CURRENT_FLIGHT_BY_ID, { id });
            });
        }
        if (this.airports != undefined) {
            mapScene.refreshAirports(this.airports);
            mapScene.setOnClickAirports((icao) => {
                liveStore.commit(SET_IS_FLIGHT_FOCUS, false);
                liveStore.dispatch(SET_CURRENT_AIRPORT_BY_ICAO, { icao });
            });
        }
        if (this.currentFlight != undefined) {
            mapScene.refreshRoute(this.currentFlight);
        }
        this.$options.mapScene = mapScene;
    },
    unmounted: function () {
        const mapScene = this.$options.mapScene;
        if (mapScene == null) {
            console.warn("Unmounting Mapbox with a null mapScene!");
            return;
        }
        mapScene.destroy();
    },
    emits: ["onClickEarth"]
});
